import { createPortal } from "react-dom";
import { Icon } from "components";
import { useDrop } from "hooks/useDrag";
import s from "./Modal.module.css";

const modalRoot = document.querySelector("#modal-root");

const Modal = ({ close, children, st = {} }) => {
    const options = useDrop();

    return createPortal(
        <div className={s.overlay}>
            <div className={s.modal} {...options} id="modal" style={st}>
                <div className={s.container}>
                    <Icon cn={s.icon} icon="close" w="15" click={close} />
                    {children}
                </div>
            </div>
        </div>,
        modalRoot
    );
};

export default Modal;
